import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import RouteManager, { PAGE_ROUTES } from "../../../managers/RouteManager";
import AppManager from "../../../managers/AppManager";
import {
    removeLoader,
    showLoader,
    showToast,
    TOAST_TYPE,
    INPUT_TYPE,
    DKIcon,
    DKIcons,
    DKButton,
    DKLabel,
    DKCalendar,
    DKTooltipWrapper,
    DKInput,
    INPUT_VIEW_DIRECTION,
    DKSearchBar,
    DKPaginator
} from "deskera-ui-library";
import "./TimesheetReport.scss";
import ic_arrow_back from "../../../assets/icons/ic_arrow_back.svg";
import SideBarService from "../../../services/sidebar";
import TimesheetService, { TIMESHEET_CONSTANTS } from "../TimesheetService";
import TimesheetUtils from "../TimesheetUtils";
import Utility from "../../../utility/Utility";
import moment from "moment";
import { DATE_FORMAT } from "../../../constants/Constant";
import ic_no_data from "../../../assets/icons/ic_no_data_3.png";


const AM_HOURS = [{ title: '12 AM', format: '0' }, { title: '1 AM', format: '1' }, { title: '2 AM', format: '2' }, { title: '3 AM', format: '3' }, { title: '4 AM', format: '4' }, { title: '5 AM', format: '5' }, { title: '6 AM', format: '6' }, { title: '7 AM', format: '7' }, { title: '8 AM', format: '8' }, { title: '9 AM', format: '9' }, { title: '10 AM', format: '10' }, { title: '11 AM', format: '11' }];
const PM_HOURS = [{ title: '12 PM', format: '12' }, { title: '1 PM', format: '13' }, { title: '2 PM', format: '14' }, { title: '3 PM', format: '15' }, { title: '4 PM', format: '16' }, { title: '5 PM', format: '17' }, { title: '6 PM', format: '18' }, { title: '7 PM', format: '19' }, { title: '8 PM', format: '20' }, { title: '9 PM', format: '21' }, { title: '10 PM', format: '22' }, { title: '11 PM', format: '23' }];
const HOURS = [...AM_HOURS, ...PM_HOURS];

function TimesheetReportCalendarView(props) {
    const history = useHistory();
    const { t } = useTranslation();
    const hoursRef = React.createRef();

    const [employeeWidth, setEmployeeWidth] = useState(Math.floor(SideBarService.getContainerWidth() * 0.30));
    const [hoursWidth, setHoursWidth] = useState(SideBarService.getContainerWidth() - employeeWidth);
    const [fetchingDependencies, setFetchingDependencies] = useState(true);
    const [customers, setCustomers] = useState([]);
    const [projects, setProjects] = useState([]);
    const [tasks, setTasks] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPageCount, setTotalPageCount] = useState(0);

    const initialFormState = {
        customer: {
            id: "customer",
            title: t("Customer"),
            type: INPUT_TYPE.DROPDOWN,
            readOnly: false,
            tooltip: "You must have books access to fetch customer"

        },
        project: {
            id: "project",
            title: t("Project"),
            type: INPUT_TYPE.DROPDOWN,
            readOnly: true,
            tooltip: "Project which belong to customer that you select"
        },
        task: {
            id: "task",
            title: t("Task"),
            type: INPUT_TYPE.DROPDOWN,
            readOnly: true,
            tooltip: "Tasks belong to customer and project as well as not below to any project"
        }
    }
    const [formState, setFormState] = useState(initialFormState);
    const [employees, setEmployees] = useState([]);
    const [searchText, setSearchText] = useState(null);
    const [showDatePicker, setShowDatePicker] = useState(false);
    const [entryDate, setEntryDate] = useState(new Date());
    const [scrollLeft, setScrollLeft] = useState(null);

    useEffect(() => {
        RouteManager.setPresenter({ props: { ...props, history: history } });
        AppManager.scrollToTop();

        window.addEventListener("onSideBarChange", onContainerResize);

        fetchDependancies();

        return () => {
            window.removeEventListener("onSideBarChange", onContainerResize);
        }
    }, []);
    useEffect(()=>{
        if(entryDate) {
            fetchDependancies();
        }
    },[entryDate,searchText,formState.task.value,formState.customer.value,formState.project.value])

    useEffect(() => {
        if (!fetchingDependencies) {
            const newFormState = { ...formState };

            if (customers) {
                newFormState.customer.options = customers?.map((customer) => {
                    return {
                        ...customer,
                        label: customer.name,
                        value: String(customer.id)
                    }
                }) || [];
            }

            setFormState(newFormState);
        }
    }, [fetchingDependencies, customers]);

    useEffect(() => {
        if (scrollLeft !== null) {
            if (hoursRef?.current) {
                hoursRef.current.scrollLeft = Math.floor((scrollLeft / 60)) * 60;
            }
        }
    }, [scrollLeft]);

    const onContainerResize = (e) => {
        setEmployeeWidth(Math.floor(SideBarService.getContainerWidth() * 0.30));
        setHoursWidth(SideBarService.getContainerWidth() - employeeWidth);
    }

    const fetchDependancies = async () => {
        showLoader();

        const dependencies = [
            TimesheetService.getCustomers(false),
            TimesheetService.getProjects(false),
            TimesheetService.getTasks(false),
            TimesheetService.getCalenderReportData(getReportConfig(entryDate))
        ];

        const response = await Promise.all(dependencies);

        const customerResponse = response[0];
        const projectResponse = response[1];
        const taskResponse = response[2];
        const reportResponse = response[3];

        if (Array.isArray(customerResponse)) {
            setCustomers(customerResponse);
        }

        if (Array.isArray(projectResponse?.data)) {
            setProjects(projectResponse.data);
        }

        if (Array.isArray(taskResponse?.data)) {
            setTasks(taskResponse.data);
        }

        if (Array.isArray(reportResponse?.data)) {
            console.log(reportResponse)
            const reportData = parseReportData(reportResponse.data);
            setEmployees(reportData);
        }

        setFetchingDependencies(false);
        removeLoader();
    }
    const getDropdownObj = (v, o) => {
        let value = v;

        const index = o.findIndex(i => i.label === v);
        if (index !== -1) {
            value = o[index];
        }

        return value;
    }
    const getReportConfig = (entryDate) => {
        const config = {
            ...TimesheetService.REPORTS_CALENDER_API_CONFIG
        };

        delete config.toDate;

        if (entryDate) {
            config.fromDate = moment(entryDate).format('YYYY-MM-DD')+'T00:00:00Z';
        }
        if(!Utility.isEmpty(formState.customer.value)) {
            config['customerId'] = getDropdownObj(formState.customer.value,formState.customer.options)?.id || '';
            if(!Utility.isEmpty(formState.project.value)) {
                config['projectId'] = getDropdownObj(formState.project.value,formState.project.options)?.id || '';
                if(!Utility.isEmpty(formState.task.value)) {
                    config['jobId'] = getDropdownObj(formState.task.value,formState.task.options)?.id || '';
                } else {
                    config['jobId'] = ''; 
                }
            } else {
                config['projectId'] = '';
                config['jobId'] = ''; 
            }
        } else {
            config['customerId'] = '';
            config['projectId'] = '';
            config['jobId'] = '';
        }

        if (searchText) {
            config.searchString = searchText?.trim();
        }

        return config;
    }

    const fetchTimesheetReport = (config) => {
        showLoader();
        TimesheetService.getReportData(config).then(
            (response) => {
                removeLoader();
                if (Array.isArray(response?.data)) {
                    const reportData = parseReportData(response.data);
                    setEmployees(reportData);
                }
            }, (error) => {
                removeLoader();
                if (error?.message) {
                    showToast(error.message, TOAST_TYPE.FAILURE);
                } else {
                    showToast("Internal server error.", TOAST_TYPE.FAILURE);
                }
            }
        );
    }

    const parseReportData = (reportData) => {
        const data = [];
        const uniqueEmpIds = new Set(reportData.map((data) => data.employeeId));

        let minScrollLeft;
        reportData.forEach((rec) => {

            let employeeName;
            let totalHrs = 0;
            let haveDraftEntry = false;
            rec.timesheetEntries.forEach((task) => {
                if (!employeeName) {
                    employeeName = rec.employeeDetails.employeeName
                }

                totalHrs += task.seconds;

                if (Utility.isEmpty(task.toDate)) {
                    haveDraftEntry = true;
                }

                const fromDate = new Date(task.fromDate);
                const scrollLeft = Math.floor(fromDate.getHours() * 60 + fromDate.getMinutes());
                if (!minScrollLeft || minScrollLeft > scrollLeft) {
                    minScrollLeft = scrollLeft;
                }
            });

            data.push({
                employeeName: employeeName,
                totalHrs: totalHrs,
                haveDraftEntry: haveDraftEntry,
                entries: rec.timesheetEntries
            });
        });

        setScrollLeft(minScrollLeft);
        
        return data;
    }

    const getDropdownLabel = (v, o) => {
        let value = v;

        const index = o.findIndex(i => i.value === v);
        if (index !== -1) {
            value = o[index].label;
        }

        return value;
    }

    const getDropdownValue = (v, o) => {
        let value = v;

        const index = o.findIndex(i => i.label === v);
        if (index !== -1) {
            value = o[index].value;
        }

        return value;
    }

    const hasError = (field, value) => {
        const error = {
            invalid: false,
            errorMessage: null
        };

        const validation = field.validation;

        if (validation && validation.length !== 0) {
            validation.forEach((validation) => {
                switch (validation[0]) {
                    case "required":
                        if (value === null || value === undefined || String(value).trim() === "") {
                            error.invalid = true;
                        }
                        break;
                    default:
                        error.invalid = false;
                        error.errorMessage = null;
                        break;
                }
            });
        }

        return error;
    }

    const isRequired = (validation) => {
        return validation ? validation.findIndex((v) => v[0] === "required") !== -1 : false;
    }

    const updateState = (stateName, field, value) => {
        const newState = { ...formState };
        newState[stateName] = { ...field, value: value, ...hasError(field, value) };
        updateValueAndValidity(stateName, newState);

        setFormState(newState);
    }

    const updateValueAndValidity = (stateName, state) => {
        switch (stateName) {
            case 'customer':
                state.project.value = null;
                state.task.value = null;

                state.task.readOnly = true;
                state.project.readOnly = false;

                const customerId = getDropdownValue(state.customer.value, state.customer.options);
                state.project.options = projects
                .filter((project) => project.customer === customerId)
                .map((project) => {
                    return {
                        ...project,
                        label: project.name,
                        value: project.id
                    }
                }) || [];
                break;
            case 'project':
                state.task.readOnly = false;

                const projectId = getDropdownValue(state.project.value, state.project.options);
                state.task.options = tasks
                .filter((task) => task.projectId === projectId)
                .map((task) => {
                    return {
                        ...task,
                        label: task.name,
                        value: task.id
                    }
                }) || [];
                break;
            default:
                break;
        }
    }

    const clearFilter = () => {
        const newState = { ...formState };
        newState.customer.value = null;
        newState.project.value = null;
        newState.task.value = null;

        newState.task.readOnly = true;
        newState.project.readOnly = true;
        setFormState(newState);
    }

    const clockOutDraftEntry = (employee) => {
        let draftEntry = employee?.entries?.find(entry=>Utility.isEmpty(entry.toDate)) || null;
        if(draftEntry) {
            onSubmitEntry(draftEntry);
        }
    }
    const onSubmitEntry = (data) => {
        if (data) {
            const payload = {
                ...data,
                toDate: moment().format(),
                status: TIMESHEET_CONSTANTS.SUBMITTED,
                
            }
            TimesheetService.updateTimesheetEntry(payload).then(() => {
                showToast("Timesheets updated", TOAST_TYPE.SUCCESS);
                fetchDependancies();
            })
        }
    }
    const renderDatePicker = () => {
        return (
            <DKCalendar
                className="position-absolute border-m shadow-m bg-white z-index-3 mt-xxl"
                isDateRange={false}
                selectedDate={entryDate}
                onSelectDate={(date) => {
                    setEntryDate(date);
                    setShowDatePicker(false);
                }}
                onClose={()=>{
                    setShowDatePicker(false);
                }}
            />
        );
    }

    const renderField = (stateName, field, width, className) => {
        switch (field.type) {
            case INPUT_TYPE.DROPDOWN:
                return (
                    <div key={field.id} style={{ flex: `${width}`, maxWidth: width }}>
                        <div className={`row position-relative ${!className ? "pr-l mb-s" : className}`}>
                            <DKInput
                                title={field.title}
                                className="list-bottom"
                                type={INPUT_TYPE.DROPDOWN}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                dropdownConfig={{
                                    allowSearch: true,
                                    searchableKey: "label",
                                    data: field.options,
                                    renderer: (i, item) => {
                                        return item.label;
                                    },
                                    onSelect: (i, value) => {
                                        updateState(stateName, field, value.label);
                                    }
                                }}
                                value={field.value}
                                errorMessage={field.errorMessage}
                                readOnly={!!field.readOnly || fetchingDependencies}
                                required={isRequired(field.validation)}
                                invalid={field.invalid}
                                canValidate={field.invalid}
                                tooltip={{
                                    content: field.tooltip,
                                    className: "popup-tooltip-prop"
                                }}
                                onChange={() => { }}
                            />
                        </div>
                    </div>
                );
            default:
                break;
        }
    }

    const renderEmployees = () => {
        return (
            <div className="parent-width employees-section">
                <div className="employee-container header">
                    <DKLabel
                        text={"Clocked In employees"}
                        className="fw-m pr-s"
                        style={{
                            minWidth: "calc(100% - 178px)",
                            width: "calc(100% - 178px)",
                            maxWidth: "calc(100% - 178px)"
                        }}
                    />
                    <DKLabel
                        text={"Total Hrs"}
                        className="fw-m pr-s"
                        style={{
                            minWidth: "85px",
                            width: "85px",
                            maxWidth: "85px"
                        }}
                    />
                </div>
                {employees.map((employee) => {
                    return (
                        <div className="employee-container employee">
                            <div className="d-flex align-items-center">
                                <div className="parent-width d-flex pr-s" style={{ minWidth: "calc(100% - 178px)", width: "calc(100% - 178px)", maxWidth: "calc(100% - 178px)" }}>
                                    <DKTooltipWrapper content={employee.employeeName} style={{ height: "fit-content" }} tooltipClassName="warning-tooltip-prop">
                                        <DKIcon src={DKIcons.ic_info} className="ic-s mr-s cursor-hand" />
                                    </DKTooltipWrapper>
                                    <DKLabel text={employee.employeeName} className="fw-m ellipsis" />
                                </div>
                                <DKLabel
                                    text={TimesheetUtils.getWorkHoursInString(employee.totalHrs)}
                                    className="text-gray fw-m pr-s"
                                    style={{
                                        minWidth: "85px",
                                        width: "85px",
                                        maxWidth: "85px"
                                    }}
                                />
                                {employee.haveDraftEntry && 
                                    <DKButton
                                        title={"Clock Out"}
                                        className="border-app text-app fw-m"
                                        style={{ padding: "3px 6px", borderRadius: "4px" }}
                                        onClick={() => {
                                            clockOutDraftEntry(employee);
                                        }}
                                    />
                                }
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }

    const renderHours = () => {
        return (
            <div>
                <div className="row">
                    {HOURS.map((hr) => {
                        return (
                            <div className="hour">
                                <DKLabel text={hr.title} className="fw-m" style={{ whiteSpace: "nowrap", minHeigh: "20px" }} />
                            </div>
                        );
                    })}
                </div>
                {employees.map((employee) => {
                    return (
                        <div className="row">
                            {HOURS.map((hr) => {
                                return (
                                    <div className="hour">
                                        <DKLabel text={""} className="fw-m" style={{ whiteSpace: "nowrap", minHeigh: "20px" }} />
                                    </div>
                                );
                            })}
                        </div>
                    );
                })}
            </div>
        );
    }

    const getEntryClass = (status) => {
        return `entry-div entry-status ${status === "_" || !status ? "draft" : String(status).toLowerCase()}`;
    }

    const renderEntry = (entry) => {
        const fromDate = new Date(entry.fromDate);
        const toDate = new Date(entry.toDate);

        const start = Math.floor(fromDate.getHours() * 60 + fromDate.getMinutes());
        const time = Math.floor((toDate.getTime() - fromDate.getTime()) / 60000);
        return (
            <div
                className={getEntryClass(entry.status)}
                style={{
                    left: start,
                    width: time,
                    minWidth: "1px"
                }}
                onClick={(e) => {
                    e.stopPropagation();
                    TimesheetUtils.showViewTimesheetEntryPopup({
                        entry: entry
                    });
                }}
            >
                <div className="entry ellipsis">
                    {entry.jobName}
                </div>
            </div>
        );
    }

    const renderEntries = () => {
        return (
            <div className="entry-section">
                {employees.map((employee) => {
                    return (
                        <div className="entry-outer-container">
                            {employee?.entries.map((entry) => renderEntry(entry))}
                        </div>
                    );
                })}
            </div>
        );
    }
    
    const getNoDataView = () => {
        return (
            <div className="column flex-1 parent-width">
            <div
                className="column align-self-center align-items-center position-absolute"
                style={{ top: "30%", pointerEvents: "none" }}
            >
                <DKIcon
                    src={ic_no_data}
                    className="ic-l"
                    style={{ opacity: 0.2, marginTop: 70 }}
                />
                <DKLabel text="No data found" className="fw-m mt-l" />
                <DKLabel
                    text="Once data is available, it will appear here"
                    className="text-gray mt-s "
                />
            </div>
            </div>
        );
    }
    
    const renderFilters = () => {
        return (
            <div>
                <DKButton
                    icon={ic_arrow_back}
                    title={t("BACK")}
                    className="pl-0 p-v-0 pr-0 cursor-hand fw-b mb-m"
                    onClick={() => {
                        RouteManager.navigateToPage(PAGE_ROUTES.TIMESHEET_REPORT_LIST);
                    }}
                />
                <div className="bg-white border-radius-m row p-h-l pb-m pt-s">
                    {renderField("customer", formState.customer, "15%")}
                    {renderField("project", formState.project, "15%")}
                    {renderField("task", formState.task, "15%")}
                    <DKTooltipWrapper content={"Clear All"} gapFromCursorY={20} style={{ height: "fit-content" }} tooltipClassName="warning-tooltip-prop tooltip-top">
                        <DKButton
                            icon={DKIcons.ic_close}
                            className="cursor-hand mt-l"
                            style={{ padding: 0 }}
                            onClick={() => {
                                clearFilter();
                            }}
                        />
                    </DKTooltipWrapper>
                    <div className="ml-auto mt-l d-flex position-relative">
                        <DKButton
                            title={Utility.formatDate(entryDate, DATE_FORMAT.IND)}
                            icon={DKIcons.ic_calendar}
                            className="bg-white mr-r border-m"
                            onClick={() => {
                                setShowDatePicker(true);
                            }}
                        />
                        {showDatePicker && renderDatePicker()}
                        <div style={{ marginRight: "-8px" }}>
                            <DKSearchBar
                                searchText={searchText}
                                onSearch={(value) => {
                                    if(value && value.length>2) {
                                        setSearchText(value);
                                    } else if(Utility.isEmpty(value)) {
                                        setSearchText(value)
                                    }
                                    
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="parent-width">
            {renderFilters()}
            <div className="mt-m parent-width bg-white border-radius-m row admin-report-calendar-view">
                <div style={{ minWidth: employeeWidth, width: employeeWidth, maxWidth: employeeWidth }}>
                    {renderEmployees()}
                </div>
                <div style={{ minWidth: hoursWidth, width: hoursWidth, maxWidth: hoursWidth, overflow: "hidden" }}>
                    <div ref={hoursRef} className="parent-width h-scroller" style={{ overflow: "auto" }}>
                        <div className="hours-section" style={{ width: "1440px" }}>
                            {renderHours()}
                            {renderEntries()}
                        </div>
                    </div>
                </div>
            </div>
            {Utility.isEmpty(employees) && getNoDataView()}
            {totalPageCount > 1 &&
                <div className="m-v-r row-reverse">
                    <DKPaginator
                        currentPage={currentPage}
                        totalCount={totalPageCount}
                        className="width-auto"
                        onPageTapped={({ page, isPrev, isNext }) => {
                            if (isPrev) {
                                
                            } else if (isNext) {
                                
                            } else {
                                
                            }
                        }}
                    />
                </div>
            }
        </div>
    );
}

export default TimesheetReportCalendarView;
